export const GET_MY_REVIEWS_ENDPOINT = '/ProductReviews/GetUserReviews';
